import { UserProfile } from 'fitbeat.gym-core';
import { PaymentMode } from 'fitbeat.models';
import { getUrls } from '../../config';
import { createUserServiceClient } from '../../utils/apiClientFactory';
import { Logger } from '../../utils/Logger';
import { openLink } from '../../utils/linkUtils';

export const getPlanType = (plan) => plan.planType;

export const isSubscriptionPlan = (plan) => plan && getPlanType(plan) === 'subscription';

export const isPAYGPlan = (plan) => plan && getPlanType(plan) === 'pay-as-you-gym';

export const isPlanTrial = (plan) => plan && plan.subscription && plan.subscription.isTrial;

export const isPlanActive = (plan) => {
  return !!plan.subscription;
};

export const isPlanCancelling = (plan) => {
  return plan.subscription && (plan.subscription.pendingCancellation || plan.subscription.cancelAtPeriodEnd);
};

export const getPlanIsDowngrading = (plan) => {
  return plan.subscription && plan.subscription.pendingDowngrade;
};

export const getValidPlanForCoupon = (coupon, plan) => {
  if (!plan) {
    return null;
  }
  return !coupon ? null : coupon.availableOnlyOnPlans.filter((availablePlan) => {
    return availablePlan.id === plan.id;
  })[0];
};

export const openPaymentRouter = (
  paymentMethod: PaymentMode,
  onceoffPriceIds: string | undefined,
  userId: string,
  coupon: string | undefined,
  planId: string,
) => {
  const { PAYMENT_ROUTER } = getUrls();
  openLink(`${PAYMENT_ROUTER}/${planId}?coupon=${coupon}&userId=${userId}` +
    `&paymentMode=${paymentMethod}&onceoff=${onceoffPriceIds}`)
    .catch((e) => Logger.notify(e));
};

export const getMemberShipPlansLink = (userProfile: UserProfile, userProfileGymNameOverride?: string) => {
  const { uid } = userProfile;
  const gymName = userProfileGymNameOverride || userProfile.gymName;
  const { GYM_WEBPAGE } = getUrls();
  const params = gymName ? `userId=${uid}&gymName=${gymName}` : `userId=${uid}`;
  return `${GYM_WEBPAGE}?${params}`;
};

export const openMembershipPlans = async (userProfile: UserProfile, userProfileGymNameOverride?: string) => {
  const { uid } = userProfile;
  const gymName = userProfileGymNameOverride || userProfile.gymName;
  const userServiceClient = createUserServiceClient();
  const { membershipPlansUrl } = await userServiceClient.getMemberShipPlansUrl(uid, gymName);
  return openLink(membershipPlansUrl);
};

export const openGymWebpage = (userProfile: UserProfile, userProfileGymNameOverride?: string) => {
  const link = getMemberShipPlansLink(userProfile, userProfileGymNameOverride);
  return openLink(link);
};
